import { TREE_CONDITIONS, type TreeCondition } from '@api/types'
import { useSearchParams } from 'wouter'

// Filtros del panel en la URL (`?estado=dry&pagina=2`): se pueden recargar y compartir.
export const parseCondition = (value: string | null): TreeCondition | undefined =>
	TREE_CONDITIONS.find((condition) => condition === value)

export const parsePage = (value: string | null): number => {
	const page = Number(value)
	return Number.isInteger(page) && page >= 1 ? page : 1
}

export const usePanelFilters = () => {
	const [params, setParams] = useSearchParams()
	const condition = parseCondition(params.get('estado'))
	const page = parsePage(params.get('pagina'))
	const update = (next: { condition?: TreeCondition; page: number }) => {
		const search = new URLSearchParams()
		if (next.condition) search.set('estado', next.condition)
		if (next.page > 1) search.set('pagina', String(next.page))
		setParams(search)
	}
	return {
		condition,
		page,
		// Cambiar de estado vuelve a la primera página.
		setCondition: (next: TreeCondition | undefined) => update({ condition: next, page: 1 }),
		setPage: (next: number) => update({ condition, page: next }),
	}
}
